import React from 'react'
import Constants from 'scripts/base/Constants'
import CookieSetting from 'scripts/lib/CookieSetting'
import ConsentCookie from 'scripts/lib/ConsentCookie'
import locale, {langPrefix} from 'shared/i18n/react'

let Country = 'xx'
if (window && window.esiParams) {
  Country = window.esiParams.cc || Country
}

const consent = new ConsentCookie()

class CookieBanner extends React.Component {
  constructor(props) {
    super(props)
    this.banner = null
    this.langPrefix = langPrefix()
  }
  componentDidMount() {
    if (this.banner) {
      setTimeout(() => { this.banner.classList.add('show') }, 1000)
    }
  }

  getRef = (node) => {
    this.banner = node
  }

  closeBanner = () => {
    if (this.banner) {
      this.banner.classList.remove('show')
    }
    setTimeout(() => { window.location.reload() }, 1000)
  }

  allowAll = (e) => {
    e.preventDefault()
    consent.Save(consent.SetAllowAll())
    this.closeBanner()
  }

  render() {
    if (Constants.EU.indexOf(Country.toLowerCase()) === -1 || typeof consent.GetData() !== 'undefined') { return null }
    return (
      <div className="cookie-banner" ref={this.getRef}>
        <div className="container row">
          <div className="col small-12 med-9">
            <div className="cookie-banner-content">
              <span>{locale.cookieConsent.banner}</span> <a href={`${this.langPrefix}/cookies`} target="_blank">{locale.buttons.learnMore}</a>
            </div>
          </div>
          <div className="col small-6 med-2 center-align">
            <CookieSetting text={locale.buttons.customize} className="uppercase" />
          </div>
          <div className="col small-6 med-1 center-align">
            <a href="javascript:;" className="btn btn-default cookie-banner-allowall" onClick={this.allowAll}>{locale.buttons.allowAll}</a>
          </div>
        </div>
      </div>
    )
  }
}

export default CookieBanner



// WEBPACK FOOTER //
// ./assets/js/components/static/CookieBanner.jsx